var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          staticStyle: { "margin-bottom": "8px" },
          attrs: { shadow: "always" }
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-right": "8px" },
              attrs: { type: "success" },
              on: { click: _vm.openLogisticDialog }
            },
            [_vm._v("菜鸟名单编辑")]
          ),
          _c("span", [
            _vm._v("已开启：" + _vm._s(_vm.nameStrForEnabledLogistic || "--"))
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-top": "8px" } }, [
            _vm._v(
              "\n      * 不启用菜鸟联通判断的快递公司，会采用ERP【物流联通表】作为判断依据。\n    "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "关闭/开启 菜鸟物流联通性设置",
            visible: _vm.dialogLogisticQueryVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogLogisticQueryVisible = $event
            },
            close: _vm.handleClose
          }
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.logisticDataToModify }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "shipping_company", label: "快递公司" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "is_open", label: "开启/关闭" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top",
                              title: "",
                              width: "",
                              trigger: "hover",
                              content: "菜鸟暂不支持查询丰网的物流轨迹",
                              disabled:
                                scope.row.shipping_company !== "丰网速运"
                            }
                          },
                          [
                            _c("el-switch", {
                              attrs: {
                                slot: "reference",
                                "active-color": "#13ce66",
                                "inactive-color": "#ff4949",
                                "active-value": 1,
                                "inactive-value": 0,
                                disabled:
                                  scope.row.shipping_company === "丰网速运"
                              },
                              slot: "reference",
                              model: {
                                value: scope.row.is_open,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "is_open", $$v)
                                },
                                expression: "scope.row.is_open"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogLogisticQueryVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveLogisticData }
                },
                [_vm._v(" 确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ys-data-table",
        {
          attrs: {
            list: _vm.searchList,
            "button-list": _vm.buttonList,
            columns: _vm.columns,
            "fetch-method": _vm.fetchMethod,
            "transform-params": _vm.handleFormatSearch,
            "page-size-alias": "pageSize",
            "page-sizes": [100, 200, 300, 400, 1000],
            "page-size": 100,
            "use-data-field": ""
          },
          on: { "selection-change": _vm.handleAreaSelectionChange },
          model: {
            value: _vm.refresh,
            callback: function($$v) {
              _vm.refresh = $$v
            },
            expression: "refresh"
          }
        },
        [
          _c(
            "template",
            { slot: "delivery" },
            [
              _c(
                "el-upload",
                {
                  ref: "pickingUpload",
                  attrs: {
                    "show-file-list": false,
                    data: { origin_id: _vm.originId },
                    "auto-upload": true,
                    limit: 1,
                    "on-success": _vm.handleSuccess,
                    "on-error": _vm.handleError,
                    "before-upload": _vm.handleBeforeUpload,
                    disabled: _vm.loadingUpload,
                    name: "excel",
                    action: _vm.action1,
                    accept:
                      ".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    "with-credentials": ""
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "trigger",
                        loading: _vm.loadingUpload,
                        type: "primary"
                      },
                      slot: "trigger"
                    },
                    [_vm._v("\n          物流联通表导入")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量停发/启用：",
            visible: _vm.dialogVisible,
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleDialogClose
          }
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "快递公司名称:", required: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "230px" },
                      attrs: { multiple: "", placeholder: "快递公司" },
                      model: {
                        value: _vm.selectedShippingCompany,
                        callback: function($$v) {
                          _vm.selectedShippingCompany = $$v
                        },
                        expression: "selectedShippingCompany"
                      }
                    },
                    _vm._l(_vm.shippingCompanyOptions, function(item) {
                      return _c("el-option", {
                        key: item.cpid,
                        attrs: {
                          label: item.shipping_company,
                          value: item.cpid
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleSubmit(_vm.START_USING)
                    }
                  }
                },
                [_vm._v("\n        启用")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.handleSubmit(_vm.BLOCK_UP)
                    }
                  }
                },
                [_vm._v("\n        停发")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导出联通性效果对比导出",
            visible: _vm.exportCNResultLogShow,
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.exportCNResultLogShow = $event
            },
            close: _vm.handleExportCNResultLogShowClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "refDownloadDialogAdvanceReceived",
              attrs: { rules: _vm.rules, model: _vm.ruleForm }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "查询日期", prop: "selectData" } },
                [
                  _c("el-date-picker", {
                    attrs: { type: "date", placeholder: "请选择查询日期" },
                    model: {
                      value: _vm.ruleForm.selectData,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "selectData", $$v)
                      },
                      expression: "ruleForm.selectData"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleExportCNResultLog }
                },
                [_vm._v("\n        导出")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function($event) {
                      _vm.exportCNResultLogShow = false
                    }
                  }
                },
                [_vm._v("\n        取消")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("ChangeLogDialog", {
        attrs: { "origin-id": _vm.originId, type: "connect" },
        model: {
          value: _vm.changeLogShow,
          callback: function($$v) {
            _vm.changeLogShow = $$v
          },
          expression: "changeLogShow"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ee5556b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ee5556b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/ShippingRule/components/ShippingConnectList.vue
// module id = null
// module chunks = 